import { render, staticRenderFns } from "./analyze.vue?vue&type=template&id=48001816&scoped=true&"
import script from "./analyze.vue?vue&type=script&lang=ts&"
export * from "./analyze.vue?vue&type=script&lang=ts&"
import style0 from "./analyze.vue?vue&type=style&index=0&id=48001816&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48001816",
  null
  
)

export default component.exports